<template>
  <div class="post-wall-card"></div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
export default {
  name: 'UserCard',
  methods: {}
};
</script>

<style scoped lang="scss">
.post-wall-card {
  width: 100%;
  height: 283px;
  padding: 18px;
  padding-bottom: 0;
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.25);
  margin-bottom: 12px;
}
</style>
